export { default } from './phoneNumber';
export type { IPhoneNumberInputComponentProps, IPhoneNumberValue, ValueFormat } from './interface';
